import React, { Component, createRef } from 'react';
import '../css/chatpage.css';
import { toast } from 'react-toastify';
import axios from 'axios';
import $ from 'jquery';
import Firebase from '../../../components/Firebase';
import lodash from 'lodash'
import { Base64 } from 'js-base64';
import MyContext from '../../../common/MyContext';
import MessageList from './MessageList';
import MessageDetailList from './MessageDetailList.js';
import ReactScroll from 'react-scrollable-feed';
import Moment from 'react-moment';

export default class MessagePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: { facebookId: props.param },
            targetUser: null,
            roomId: "",
            messages: [],
            messageDetails: [],
            searchUsers: [],
            cursorMessageDetails: null,
            loaded: false,
            isFirst: false,
            loading: false,
            listenFirebaseMessages: null,
            listenFirebaseMessgeDetails: null,
            message: "",
            searchKeyword: "",
            isUserActive: false,
            viewFilter: "all",
            botEnableReply: true, // Mặc định là bật nếu không có giá trị trong Firebase
            listenBotEnableReply: null,
        }
        this.ikaraNode = Firebase.database().ref("ikara");
        this.functions = Firebase.functions();
        this.auth = Firebase.auth();
        this.getFirebaseToken = this.getFirebaseToken.bind(this);
        this.accessToken = this.accessToken.bind(this);
        this.listenFirebaseMessages = this.listenFirebaseMessages.bind(this);
        this.listenFirebaseMessgeDetails = this.listenFirebaseMessgeDetails.bind(this);
        this.getMessageDetail = this.getMessageDetail.bind(this);
        this.loadMoreMessageDetails = this.loadMoreMessageDetails.bind(this);
        this.offListen = this.offListen.bind(this);
        this.handleTargetUser = this.handleTargetUser.bind(this);
        this.sendMessage = this.sendMessage.bind(this);
        this.uploadImage = this.uploadImage.bind(this);
        this.acceptSendVideo = this.acceptSendVideo.bind(this);
        this.isWithin30Days = this.isWithin30Days.bind(this);
        this.chatContainerRef = createRef();
        this.messagesBoxRef = createRef();
        this.currentTimeout = null;  
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.clearSearchKeyword = this.clearSearchKeyword.bind(this);
        this.refreshConversations = this.refreshConversations.bind(this);
        this.handleBotEnableReplyChange = this.handleBotEnableReplyChange.bind(this);
        this.listenBotEnableReply = this.listenBotEnableReply.bind(this);
        this.handleAvatarClick = this.handleAvatarClick.bind(this);
        this.fileReaderRefs = []; // Lưu các FileReader để cleanup
    }

    componentDidMount() {
        if (!this.state.loaded) {
            this.getFirebaseToken();
        }
    }

    componentWillUnmount() {
        // Cleanup listeners
        const { listenBotEnableReply, listenFirebaseMessgeDetails } = this.state;
        if (listenBotEnableReply && typeof listenBotEnableReply === 'function') {
            listenBotEnableReply();
        }
        if (listenFirebaseMessgeDetails && typeof listenFirebaseMessgeDetails === 'function') {
            listenFirebaseMessgeDetails();
        }
        const { listenFirebaseMessages } = this.state;
        if (listenFirebaseMessages && listenFirebaseMessages.off) {
            listenFirebaseMessages.off();
        }
        
        // Cleanup FileReader references
        this.fileReaderRefs = [];
        
        // Clear timeout nếu có
        if (this.currentTimeout) {
            clearTimeout(this.currentTimeout);
            this.currentTimeout = null;
        }
    }

    componentDidUpdate(prevProps) {
        // Kiểm tra nếu prop user thay đổi
        if (this.props.param && this.props.param !== prevProps.param) {
            this.setState({
                user: { facebookId: this.props.param },
                targetUser: null,
                roomId: "",
                messages: [],
                messageDetails: [],
                searchUsers: [],
                cursorMessageDetails: null,
                loaded: false,
                isFirst: false,
                loading: false,
                listenFirebaseMessages: null,
                listenFirebaseMessgeDetails: null,
                message: "",
                searchKeyword: "",
                isUserActive: false,
                viewFilter: "all",
            }, () => {
                this.getFirebaseToken();
            });
        }
    }

    handleScroll() {
        const { loading, loaded } = this.state;
        if ($('.chat-box').scrollTop() < 150 && !loading && loaded) {
            this.state.loading = true;
            this.loadMoreMessageDetails()
        }
    }

    getFirebaseToken() {
        let { user } = this.state;
        axios.post(global.config.apiDomain + "/rest/admin/getFirebaseToken", user.facebookId, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then(res => {
                if (res.data != null) {
                    this.setState({ user: res.data.user }, () => {
                        this.accessToken();
                    });
                }
            })
            .catch(error => {
                console.error("Error fetching Firebase token:", error);
            });
    }

    acceptSendVideo() {
        let acceptSendVideo = false;
        if (this.state.messageDetails && this.state.messageDetails.length > 1) {
            let firstUser = this.state.messageDetails[0].userId;
            this.state.messageDetails.map(value => {
                if (value.userId && value.userId !== firstUser) {
                    acceptSendVideo = true;
                }
            })
        }
        return acceptSendVideo;
    }

    accessToken() {
        const { user } = this.state;
        this.auth.signInWithCustomToken(user.firebaseToken)
            .then(res => {
                this.listenFirebaseMessages();
            }).catch(error => {
                this.listenFirebaseMessages();
            });
    }

    uploadImage = (event) => {
        const uploadBotId = this.state.user?.facebookId;
        const uploadTargetId = this.state.targetUser?.fromUserId;
        if (window.confirm("Bạn có chắc muốn gửi file này ?")) {
            var target = event.target;
            if (target.files[0].size > 10495760) {
                toast.error("Kích thước file phải dưới 10mb.");
                return;
            }
            this.setState({
                loading: true
            });
            var bucketName = "ikara-data/chat";
            var extension = target.files[0].name.split('.').pop().toLowerCase();
            var keyName = this.guid() + "." + extension;
            var contentType = "image/jpeg";
            if (extension == "mp4") {
                contentType = "video/mp4";
            }
            if (extension == "mov") {
                contentType = "video/mov";
            }
            if (extension !== "jpeg" && extension !== "jpg" && extension !== "png" && extension !== "mp4" && extension !== "mov") {
                toast.warn("Không đúng định dạng")
                this.setState({
                    loading: false
                });
                return;
            }
            if ((extension === "mp4" || extension === "mov") && !this.acceptSendVideo()) {
                toast.warn("Không thể gửi video do chưa xác lập hội thoại")
                this.setState({
                    loading: false
                });
                return;
            }
            var fileReader = new FileReader();
            // Lưu reference để cleanup sau
            this.fileReaderRefs.push(fileReader);
            
            fileReader.onload = function () {
                this.setState({
                    loading: true,
                    message: 'Loading image...'
                });
                var fd = new FormData();
                fd.append('file', target.files[0]);
                fd.append('bucketName', bucketName);
                fd.append('objectKey', keyName);
                fd.append('contentType', contentType)
                $.ajax({
                    url: global.config.apiDomain + '/web.UploadFile ',
                    data: fd,
                    processData: false,
                    contentType: false,
                    type: 'POST',
                    success: function (data) {
                        if (this.state.user?.facebookId !== uploadBotId || this.state.targetUser?.fromUserId !== uploadTargetId) {
                            this.setState({loading:false});
                            toast.info('Đã đổi hội thoại; tệp chưa được gửi.');
                            return;
                        }
                        this.setState({loading:false,
                            message:'["https://data4.ikara.co/data/minio/' + bucketName + '/' + keyName + '"]'
                        }, () => this.sendMessage(extension === 'mp4' ? 'video' : 'image'));
                        // Remove FileReader reference sau khi hoàn thành
                        const index = this.fileReaderRefs.indexOf(fileReader);
                        if (index > -1) {
                            this.fileReaderRefs.splice(index, 1);
                        }
                    }.bind(this), 
                    error: function (jqXHR, exception) {
                        toast.error(exception);
                        this.setState({
                            loading: false
                        });
                        // Remove FileReader reference khi có lỗi
                        const index = this.fileReaderRefs.indexOf(fileReader);
                        if (index > -1) {
                            this.fileReaderRefs.splice(index, 1);
                        }
                    }.bind(this),
                });
            }.bind(this);
            
            fileReader.onerror = function() {
                toast.error("Lỗi đọc file");
                this.setState({ loading: false });
                const index = this.fileReaderRefs.indexOf(fileReader);
                if (index > -1) {
                    this.fileReaderRefs.splice(index, 1);
                }
            }.bind(this);
            
            fileReader.readAsArrayBuffer(target.files[0]);
        }
    }

    guid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }

    getMessageDetail() {
        const { user, targetUser } = this.state;
        if (!targetUser) return; // Thêm kiểm tra này để đảm bảo targetUser tồn tại

        var roomId = "";
        if (user.facebookId > targetUser.fromUserId) {
            roomId = targetUser.fromUserId + "-" + user.facebookId;
        } else {
            roomId = user.facebookId + "-" + targetUser.fromUserId;
        }
        this.setState({ roomId }, () => {
            this.ikaraNode
                .child("privateChats")
                .child(roomId)
                .orderByKey()
                .limitToLast(100) // Load 100 tin nhắn gần nhất ban đầu
                .get()
                .then(snapshot => {
                    var messageDetails = [];
                    snapshot.forEach(value => {
                        var chatItem = value.val();
                        chatItem.key = value.key;
                        if (chatItem.key != "pushNotification"
                            && chatItem.key != "readLimit"
                            && chatItem.key != "properties") {
                            if (chatItem.type != null && !(chatItem.type == "text" || chatItem.type == "image")) {
                                chatItem.originalMessage = "Chưa hỗ trợ xem data";
                            }
                            messageDetails.push(chatItem);
                        }
                    })
                    // Sắp xếp theo thời gian để đảm bảo thứ tự đúng
                    messageDetails.sort((a, b) => (a.dateTime || 0) - (b.dateTime || 0));
                    
                    let cursorMessageDetails = messageDetails.length < 9 ? "END" : messageDetails[0].key;
                    this.setState({
                        messageDetails: messageDetails,
                        cursorMessageDetails: cursorMessageDetails,
                        loaded: true
                    }, () => {
                        this.scrollToBottom();
                        this.listenFirebaseMessgeDetails();
                        this.listenBotEnableReply(roomId);
                    });
                })
                .catch(error => {
                    console.error("Error loading message details:", error);
                    this.setState({ loaded: true });
                });
        });
    }

    loadMoreMessageDetails() {
        const { roomId, loading } = this.state;
        let { cursorMessageDetails } = this.state;
        if (cursorMessageDetails == "END" || loading) return;
        
        this.setState({ loading: true });
        
        this.ikaraNode
            .child("privateChats")
            .child(roomId)
            .orderByKey()
            .endAt(cursorMessageDetails)
            .limitToLast(50) // Tăng từ 10 lên 50 để giảm số lần query
            .get()
            .then(snapshot => {
                var messageDetails = [];
                snapshot.forEach(value => {
                    var chatItem = value.val();
                    chatItem.key = value.key;
                    if (!this.state.messageDetails.some(o => o.key == chatItem.key)) {
                        messageDetails.push(chatItem);
                    }
                })
                
                // Giới hạn tổng số tin nhắn trong state để tránh tràn RAM
                // Chỉ giữ 1000 tin nhắn gần nhất
                const MAX_MESSAGES_IN_STATE = 1000;
                let updatedMessageDetails = messageDetails.concat(this.state.messageDetails);
                
                if (updatedMessageDetails.length > MAX_MESSAGES_IN_STATE) {
                    // Giữ lại những tin nhắn mới nhất (sắp xếp theo dateTime)
                    updatedMessageDetails.sort((a, b) => (a.dateTime || 0) - (b.dateTime || 0));
                    updatedMessageDetails = updatedMessageDetails.slice(-MAX_MESSAGES_IN_STATE);
                }
                
                if (messageDetails.length < 9) {
                    this.setState({
                        cursorMessageDetails: "END",
                        messageDetails: updatedMessageDetails,
                        loading: false
                    });
                } else if (messageDetails.length > 0) {
                    this.setState({
                        cursorMessageDetails: messageDetails[0].key,
                        messageDetails: updatedMessageDetails,
                        loading: false
                    });
                } else {
                    this.setState({ loading: false });
                }
            })
            .catch(error => {
                console.error("Error loading more messages:", error);
                this.setState({ loading: false });
            });
    }

    isWithin30Days(timestamp) {
        const currentTime = Date.now();
        const timeDifference = currentTime - timestamp;
        const days30 = 30 * 24 * 60 * 60 * 1000;
        return timeDifference <= days30;
    }


    listenFirebaseMessages() {
        const { user } = this.state;
        const listenFirebaseMessages = this.ikaraNode
            .child("bots")
            .child(user.facebookId)
            .child("privateChats");
        this.setState({ listenFirebaseMessages });

        listenFirebaseMessages.on('value', snapshot => {
            let messagesSnapshot = [];
            snapshot.forEach(value => {
                const message = value.val();
                message.fromUserId = value.key;
                const isWithin30Days = this.isWithin30Days(message.dateTime);
                if (isWithin30Days) {
                    messagesSnapshot.push(message);
                }
            });
            messagesSnapshot = lodash.orderBy(messagesSnapshot, "dateTime", 'desc').slice(0, 100);
            this.setState(prevState => {
                const baseList = this.getFilteredMessages(messagesSnapshot, prevState.viewFilter);
                const keyword = prevState.searchKeyword.trim().toLowerCase();
                const nextSearchUsers = keyword.length > 0 ? this.filterMessagesByKeyword(baseList, keyword) : [];
                return {
                    messages: messagesSnapshot,
                    loaded: true,
                    searchUsers: nextSearchUsers
                };
            }, () => {
                this.scrollToBottom();
                // this.runForLoop(messages);
            });
        });
    }

    runForLoop(messages) {
        let currentIndex = 0;
        const executeLoop = () => {
            if (this.state.isUserActive) {
                return;
            }

            if (currentIndex >= messages.length) {
                return;
            }

            this.setState({ targetUser: messages[currentIndex] }, () => {
                if (currentIndex >= 5) {
                    this.scrollToBottom1();
                }
                // if (!this.state.targetUser.isRead) {
                //     this.changeIsReadConversation(this.state.targetUser);
                // }
                this.getMessageDetail();
                // Do not increment currentIndex or call executeLoop again
            });
        };

        if (this.currentTimeout) {
            clearTimeout(this.currentTimeout);
        }
        executeLoop();
    }

    // runForLoop(messages) {
    //     let currentIndex = 0;
    //     const executeLoop = () => {
    //         if (this.state.isUserActive) {
    //             this.currentTimeout = setTimeout(executeLoop, 5000);
    //             return;
    //         }

    //         if (currentIndex >= messages.length) {
    //             return;
    //         }

    //         this.setState({ targetUser: messages[currentIndex] }, () => {
    //             if (currentIndex >= 5) {
    //                 this.scrollToBottom1();
    //             }
    //             if (!this.state.targetUser.isRead) {
    //                 this.changeIsReadConversation(this.state.targetUser);
    //             }
    //             this.getMessageDetail();
    //             currentIndex++;
    //             this.currentTimeout = setTimeout(executeLoop, 20000);
    //         });
    //     };

    //     if (this.currentTimeout) {
    //         clearTimeout(this.currentTimeout);
    //     }
    //     executeLoop();
    // }

    handleInputChange = (event) => {
        const value = event.target.value;
        this.setState({
            message: value,
            isUserActive: value.length > 0
        });
    }

    handleSearchChange(event) {
        const value = event.target.value;
        const keyword = value.trim().toLowerCase();
        const baseList = this.getFilteredMessages(this.state.messages, this.state.viewFilter);
        const searchUsers = keyword.length > 0 ? this.filterMessagesByKeyword(baseList, keyword) : [];
        this.setState({
            searchKeyword: value,
            searchUsers: searchUsers
        });
    }

    clearSearchKeyword() {
        this.setState({
            searchKeyword: "",
            searchUsers: []
        });
    }

    refreshConversations() {
        const { listenFirebaseMessages: messagesListener } = this.state;
        if (messagesListener && messagesListener.off) {
            messagesListener.off();
        }
        this.listenFirebaseMessages();
    }

    handleAvatarClick(userId, event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (userId) {
            const url = global.config.apiDomain + '/admin/account-manager?id=' + userId;
            window.open(url, '_blank');
        }
    }

    handleBotEnableReplyChange(event) {
        const { roomId } = this.state;
        if (!roomId) return;
        
        const newValue = event.target.checked;
        this.ikaraNode
            .child("privateChats")
            .child(roomId)
            .child("properties")
            .child("botEnableReply")
            .set(newValue)
            .catch(error => {
                console.error("Error updating botEnableReply:", error);
            });
    }

    listenBotEnableReply(roomIdParam = null) {
        const roomId = roomIdParam || this.state.roomId;
        if (!roomId) return;

        const { listenBotEnableReply: currentListener } = this.state;
        // Cleanup listener cũ nếu có
        if (currentListener && typeof currentListener === 'function') {
            currentListener();
        }

        const botEnableReplyRef = this.ikaraNode
            .child("privateChats")
            .child(roomId)
            .child("properties")
            .child("botEnableReply");

        const offListener = botEnableReplyRef.on('value', snapshot => {
            if (snapshot && snapshot.exists()) {
                const value = snapshot.val();
                this.setState({
                    botEnableReply: value === true
                });
            } else {
                // Nếu không có botEnableReply thì button được tính là bật
                this.setState({
                    botEnableReply: true
                });
            }
        });

        this.setState({
            listenBotEnableReply: offListener
        });
    }

    getFilteredMessages = (messages, filterKey) => {
        switch (filterKey) {
            case "need-support":
                return messages.filter(item => item.lastUserId !== this.state.user.facebookId);
            case "bot-only":
                return messages.filter(item => item.lastUserId === this.state.user.facebookId);
            default:
                return messages;
        }
    }

    filterMessagesByKeyword = (list, keyword) => {
        return list.filter(item => {
            const name = (item.userName || "").toLowerCase();
            let lastMessage = item.lastMessage;
            if (lastMessage && typeof lastMessage === "object") {
                lastMessage = JSON.stringify(lastMessage);
            }
            const snippet = (lastMessage || "").toLowerCase();
            return name.includes(keyword) || snippet.includes(keyword);
        });
    }

    setViewFilter = (filterKey) => {
        this.setState(prevState => {
            const baseList = this.getFilteredMessages(prevState.messages, filterKey);
            const keyword = prevState.searchKeyword.trim().toLowerCase();
            const searchUsers = keyword.length > 0 ? this.filterMessagesByKeyword(baseList, keyword) : [];
            return {
                viewFilter: filterKey,
                searchUsers
            };
        });
    }

    renderConversationSkeleton() {
        return (
            <div className="skeleton-list">
                {[...Array(6)].map((_, index) => (
                    <div className="skeleton-item" key={index}>
                        <div className="skeleton-avatar"></div>
                        <div className="skeleton-lines">
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    handleKeyPress = (event) => {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            this.sendMessage("text");
        }
    }

    offListen() {
        const { listenFirebaseMessages, listenFirebaseMessgeDetails } = this.state;
        // Cleanup message details listener
        if (listenFirebaseMessgeDetails && typeof listenFirebaseMessgeDetails === 'function') {
            listenFirebaseMessgeDetails();
        } else if (listenFirebaseMessgeDetails && listenFirebaseMessgeDetails.off) {
            listenFirebaseMessgeDetails.off();
        }
    }

    listenFirebaseMessgeDetails() {
        const { user, targetUser } = this.state;
        if (!targetUser) return;
        
        // Cleanup listener cũ nếu có
        const { listenFirebaseMessgeDetails: currentListener } = this.state;
        if (currentListener && typeof currentListener === 'function') {
            currentListener();
        } else if (currentListener && currentListener.off) {
            currentListener.off();
        }

        var roomId = "";
        if (user.facebookId > targetUser.fromUserId) {
            roomId = targetUser.fromUserId + "-" + user.facebookId;
        } else {
            roomId = user.facebookId + "-" + targetUser.fromUserId;
        }
        this.setState({ roomId });

        const roomRef = this.ikaraNode
            .child("privateChats")
            .child(roomId);

        // Hàm xử lý cập nhật tin nhắn
        const handleMessageUpdate = (snapshot, isNewMessage = false) => {
            if (!snapshot || !snapshot.exists()) return;
            
            var chatItem = snapshot.val();
            chatItem.key = snapshot.key;
            
            // Bỏ qua các key không phải tin nhắn
            if (chatItem.key === "pushNotification" || 
                chatItem.key === "readLimit" || 
                chatItem.key === "properties") {
                return;
            }

            if (chatItem.type != null && !(chatItem.type == "text" || chatItem.type == "image")) {
                chatItem.originalMessage = "Chưa hỗ trợ xem data";
            }

            this.setState(prevState => {
                let updatedMessageDetails = [...prevState.messageDetails];
                
                // Tìm xem tin nhắn đã tồn tại chưa
                const existingIndex = updatedMessageDetails.findIndex(
                    msg => msg.key === chatItem.key || 
                           (msg.firebaseId && msg.firebaseId === chatItem.firebaseId) ||
                           (msg.isLocalOnly && msg.message === chatItem.message && msg.type === chatItem.type)
                );

                if (existingIndex >= 0) {
                    // Chỉ update nếu có thay đổi thực sự để tránh re-render không cần thiết
                    const existing = updatedMessageDetails[existingIndex];
                    if (existing.originalMessage !== chatItem.originalMessage ||
                        existing.message !== chatItem.message ||
                        existing.dateTime !== chatItem.dateTime) {
                        updatedMessageDetails[existingIndex] = { ...chatItem, isLocalOnly: false };
                    } else {
                        // Không có thay đổi, không cần update state
                        return null;
                    }
                } else {
                    // Thêm tin nhắn mới
                    updatedMessageDetails.push(chatItem);
                    
                    // Giới hạn số lượng tin nhắn trong state để tránh tràn RAM
                    const MAX_MESSAGES_IN_STATE = 1000;
                    if (updatedMessageDetails.length > MAX_MESSAGES_IN_STATE) {
                        // Giữ lại tin nhắn mới nhất, loại bỏ tin nhắn cũ nhất
                        updatedMessageDetails.sort((a, b) => (a.dateTime || 0) - (b.dateTime || 0));
                        updatedMessageDetails = updatedMessageDetails.slice(-MAX_MESSAGES_IN_STATE);
                    }
                }

                // Sắp xếp lại tin nhắn theo thời gian
                updatedMessageDetails.sort((a, b) => (a.dateTime || 0) - (b.dateTime || 0));

                return { messageDetails: updatedMessageDetails };
            }, () => {
                // Chỉ scroll khi có tin nhắn mới được thêm vào (không phải khi load lại tin nhắn cũ)
                if (isNewMessage) {
                    this.scrollToBottom();
                }
            });
        };

        // Lắng nghe child_added cho tin nhắn mới (chỉ scroll khi là tin nhắn mới)
        roomRef.on('child_added', (snapshot) => handleMessageUpdate(snapshot, true));
        
        // Lắng nghe child_changed cho tin nhắn được cập nhật (không scroll)
        roomRef.on('child_changed', (snapshot) => handleMessageUpdate(snapshot, false));

        // Lưu hàm cleanup
        const offListener = () => {
            roomRef.off('child_added', handleMessageUpdate);
            roomRef.off('child_changed', handleMessageUpdate);
        };

        this.setState({ listenFirebaseMessgeDetails: offListener });
    }

    handleTargetUser(targetUser) {
        const oldTargetUser = this.state.targetUser;
        if (oldTargetUser != null && targetUser.fromUserId == oldTargetUser.fromUserId) {
            return;
        }

        // Cleanup botEnableReply listener trước khi chọn user mới
        const { listenBotEnableReply: currentListener } = this.state;
        if (currentListener && typeof currentListener === 'function') {
            currentListener();
        }

        this.setState({
            targetUser: targetUser,
            searchKeyword: "",
            searchUsers: [],
            messageDetails: [], // Reset messageDetails khi chọn user mới
            botEnableReply: true, // Mặc định là bật, sẽ được cập nhật từ Firebase
            listenBotEnableReply: null
        }, () => {
            // if (!targetUser.isRead) {
            //     this.changeIsReadConversation(targetUser);
            // }
            if (oldTargetUser != null) {
                this.offListen();
            }
            this.getMessageDetail();
        });

        if (!this.state.messages.some(o => o.fromUserId == targetUser.fromUserId)) {
            this.setState(prevState => ({
                messages: [targetUser, ...prevState.messages]
            }));
        }
    }

    changeIsReadConversation(targetUser) {
        const json = {
            toFacebookId: targetUser.fromUserId
        }
        const jsonBase64 = Base64.encode(JSON.stringify(json));
        const parameters = {
            "parameters": jsonBase64
        }
        const request = this.functions.httpsCallable("v5-ChangeIsReadConversation");
        request(parameters)
            .then(result => {
            }).catch(error => {
                alert(error);
            });
    }

    sendMessage = async (type) => {
        const { user, targetUser, message } = this.state;
        if (!message || !user || !targetUser || this.state.sending) return;
        const botId = user.facebookId;
        const recipientId = targetUser.fromUserId;
        this.setState({sending:true});
        try {
            const body = {toUserId:recipientId, message, type,
                friendStatus:'NOTFRIEND', language:this.props.market === 'PH' ? 'en.yosing' : (user.language === 'vi' ? 'vi' : 'en.yokara')};
            if (type === 'image' || type === 'video') {
                const urls = JSON.parse(message);
                if (!Array.isArray(urls) || !urls.length) throw new Error('Tệp đính kèm không hợp lệ');
                body.media = urls.map(url => ({url, mimeType:type === 'video' ? 'video/mp4' : /\.png(?:[?#]|$)/i.test(url) ? 'image/png' : 'image/jpeg'}));
            }
            const result = await this.functions.httpsCallable('v13-SendMessage')({parameters:Base64.encode(JSON.stringify(body))});
            const payload = typeof result.data === 'string' ? JSON.parse(result.data) : result.data;
            if (!payload || payload.status !== 'OK') throw new Error(payload?.message || 'Không gửi được tin nhắn');
            if (this.state.user?.facebookId === botId && this.state.targetUser?.fromUserId === recipientId) this.setState({message:''});
        } catch (error) { toast.error(error.message || 'Không gửi được tin nhắn'); }
        finally { this.setState({sending:false}); }
    };

    scrollToBottom = () => {
        if (this.chatContainerRef.current) {
            this.chatContainerRef.current.scrollTop = this.chatContainerRef.current.scrollHeight;
        }
    }

    scrollToBottom1 = () => {
        if (this.messagesBoxRef.current) {
            const currentScrollTop = this.messagesBoxRef.current.scrollTop;
            const newScrollTop = currentScrollTop + 200;
            const maxScrollTop = this.messagesBoxRef.current.scrollHeight - this.messagesBoxRef.current.clientHeight;
            this.messagesBoxRef.current.scrollTop = Math.min(newScrollTop, maxScrollTop);
        }
    }

    scrollToTop = () => {
        if (this.messagesBoxRef.current) {
            this.messagesBoxRef.current.scrollTop = 0;
        }
    }

    render() {
        const { user, targetUser, messages, messageDetails, searchUsers, loaded, message, searchKeyword, viewFilter } = this.state;
        const filterOptions = [
            { key: "all", label: "Tất cả" },
            { key: "need-support", label: "Cần chăm sóc" },
            { key: "bot-only", label: "BOT xử lý" }
        ];
        const filteredMessages = this.getFilteredMessages(messages, viewFilter);
        const showingMessages = (searchKeyword && searchKeyword.trim().length > 0) ? searchUsers : filteredMessages;
        const hasConversations = showingMessages.length > 0;
        const activeUserName = targetUser ? targetUser.userName : "Chưa chọn";
        const activeUserId = targetUser ? `#${targetUser.fromUserId}` : "Chạm để chọn hội thoại";
        const heroStatusClass = 'hero-status hero-status-success';

        return (
            <div className="workspace-grid">
                    <section className="bot-list-panel">
                        <div className="panel-heading">
                            <div>
                                <h4 className="panel-title">Hội thoại</h4>
                            </div>
                            <div className="panel-actions">
                                <span className="conversation-counter">{messages.length}</span>
                            </div>
                        </div>
                        <div className="search-wrapper">
                            <i className="fa-solid fa-magnifying-glass search-icon"></i>
                            <input
                                type="text"
                                className="search-input"
                                placeholder="Tìm theo tên hoặc nội dung..."
                                value={searchKeyword}
                                onChange={this.handleSearchChange}
                            />
                            {searchKeyword && (
                                <button className="clear-search" onClick={this.clearSearchKeyword}>
                                    <i className="fa-solid fa-xmark"></i>
                                </button>
                            )}
                        </div>
                        <div className="conversation-list messages-box" ref={this.messagesBoxRef}>
                            {!loaded ? (
                                this.renderConversationSkeleton()
                            ) : hasConversations ? (
                                <MessageList
                                    messages={showingMessages}
                                    user={user}
                                    targetUser={targetUser || {}}
                                    handleTargetUser={this.handleTargetUser}
                                    handleAvatarClick={this.handleAvatarClick}
                                />
                            ) : (
                                <div className="list-empty-state">
                                    <i className="fa-regular fa-circle-question"></i>
                                    <p>Không tìm thấy hội thoại</p>
                                    <span>Hãy thử đổi bộ lọc hoặc từ khóa tìm kiếm.</span>
                                </div>
                            )}
                        </div>
                    </section>

                    <section className="conversation-panel">
                        {targetUser ? (
                            <>
                                <div className="chat-top-bar">
                                    <div className="user-identity">
                                        <img 
                                            src={targetUser.userProfile} 
                                            alt={targetUser.userName} 
                                            className="user-avatar" 
                                            style={{ cursor: 'pointer' }}
                                            onClick={(e) => this.handleAvatarClick(targetUser.fromUserId, e)}
                                        />
                                        <div>
                                            <h6>{targetUser.userName}</h6>
                                            <span className="user-id">#{targetUser.fromUserId}</span>
                                        </div>
                                    </div>
                                    <div className="chat-top-bar-slider">
                                        <span className="slider-label">Tiếp tục phản hồi:</span>
                                        <label className="toggle-switch">
                                            <input
                                                type="checkbox"
                                                checked={this.state.botEnableReply}
                                                onChange={this.handleBotEnableReplyChange}
                                            />
                                            <span className="slider"></span>
                                        </label>
                                    </div>
                                </div>
                                <div className="chat-container" ref={this.chatContainerRef}>
                                    <ReactScroll
                                        className="mt-2 px-4 chat-box bg-white">
                                        {messageDetails.length > 0 ? (
                                            <MessageDetailList
                                                messageDetails={messageDetails}
                                                user={user}
                                                targetUser={targetUser}
                                            />
                                        ) : (
                                            <div className="chat-empty-state">
                                                <i className="fa-regular fa-comments"></i>
                                                <p>Chưa có tin nhắn nào trong cuộc hội thoại này.</p>
                                                <span>Bạn có thể gửi tin nhắn đầu tiên để bắt chuyện.</span>
                                            </div>
                                        )}
                                    </ReactScroll>
                                </div>
                                <div className="input-container-bot">
                                    <div className="composer-shell">
                                        <label htmlFor="imageBotReply" className="icon-button" title="Gửi ảnh / video">
                                            <i className="fa-solid fa-image"></i>
                                        </label>
                                        <input
                                            type="file"
                                            id="imageBotReply"
                                            className="custom-file-input"
                                            onChange={this.uploadImage}
                                            style={{ display: 'none' }}
                                        />
                                        <textarea
                                            rows={1}
                                            onKeyPress={this.handleKeyPress}
                                            value={message}
                                            onChange={this.handleInputChange}
                                            placeholder="Nhập tin nhắn để trao đổi với người dùng..."
                                            aria-describedby="button-bot"
                                            className="message-textarea"
                                        />
                                        <button
                                            className="btn btn-primary send-button"
                                            disabled={!message.trim()}
                                            onClick={() => this.sendMessage("text")}
                                        >
                                            <i className="fa-solid fa-paper-plane"></i>
                                        </button>
                                    </div>
                                    <span className="composer-note">Nhấn Enter để gửi nhanh.</span>
                                </div>
                            </>
                        ) : (
                            <div className="no-user-selected">
                                <i className="fa-regular fa-comments"></i>
                                <p>Chưa chọn hội thoại</p>
                                <span>Hãy chọn một người dùng bên trái để xem và thay BOT trả lời.</span>
                            </div>
                        )}
                    </section>
                </div>
        );
    }
}

MessagePage.contextType = MyContext;